

















import ApiClient from '@/common/api'
import BlueButton from '@/views/atoms/BlueButton.vue'
import Global from '@/common/global.js'
import store from '@/store'
import Pager from '@/views/organisms/Pager.vue'

export default
  components: {
    ApiClient
    BlueButton
    Pager
  }
  data: () ->
    members: []
    level: Global.level()
    customsBrokerList: store.getters.customsBrokerList,
    page: {}
    page_number: '1'

  created: () ->
    store.dispatch('initPostParam')
    store.dispatch('setErrors', [])
    @getCustomsBroker()

  methods: {
    click_new: (e) ->
      @$router.push 'customs_broker_edit'
    customsBrokerDelete: (id) ->
      param =
        id: id
      api = new ApiClient()
      data = await api.post('/fc/customs_broker/delete', param)
      if data.errors.length == 0
        @getCustomsBroker()
    getCustomsBroker: () ->
      api = new ApiClient()
      data = await api.get('/fc/customs_broker/list/' + @page_number)
      @members = data.list
      @page = data.page
    detail_click: (id) ->
      @$router.push '/customs_broker_edit/detail/' + id
    customsBrokerName: (id) ->
      for row, index in @customsBroker
        if row.id == id
          return row.name
      return ''
    move_page: (page) ->
      @page_number = page
      @getCustomsBroker()
  }

